import { h } from "preact";
import { classNames, renderIcon } from "../helpers";
import tracking from "../tracking/tracking";

export default function DropdownList({
  closer,
  filter,
  items,
  onClick,
  title,
  ...ulProps
}) {
  return (
    <ul
      {...ulProps}
      class={classNames(
        "filter__dropdown dropdown-content dropdown-list",
        ulProps.class
      )}
    >
      {title && (
        <li
          class={classNames(
            "dropdown-list__item",
            "dropdown-list__item--title"
          )}
        >
          {title}
        </li>
      )}
      {filter && (
        <li
          class={classNames(
            "dropdown-list__item",
            "dropdown-list__item--filter"
          )}
        >
          {filter}
        </li>
      )}
      {items.map((item) => (
        <li
          value={item.value}
          {...item.props}
          class={classNames("dropdown-list__item", item.props?.class)}
          onClick={(event) => {
            if (item.trackingName) {
              tracking.track("dropdown.click", {
                name: `${item.trackingName}`,
              });
            }
            if (item.onClick) {
              item.onClick();
              closer && closer();
            } else {
              onClick(item.value);
            }
          }}
        >
          {item.content || (
            <span className="dropdown-list__item__wrapper">
              {item.icon &&
                renderIcon(item.icon, "dropdown-list__item__icon mr-8")}
              <span>{item.text}</span>
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}
